var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4175 19.8962H22.0408C19.8633 19.8962 18.8125 18.8887 18.8125 16.8087V9.44199C18.8125 7.36199 19.8742 6.35449 22.0408 6.35449H26.4175C28.595 6.35449 29.6458 7.36199 29.6458 9.44199V16.8087C29.6458 18.8887 28.5842 19.8962 26.4175 19.8962ZM22.0408 7.97949C20.665 7.97949 20.4375 8.34783 20.4375 9.44199V16.8087C20.4375 17.9028 20.665 18.2712 22.0408 18.2712H26.4175C27.7933 18.2712 28.0208 17.9028 28.0208 16.8087V9.44199C28.0208 8.34783 27.7933 7.97949 26.4175 7.97949H22.0408V7.97949Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4175 29.6455H22.0408C19.8633 29.6455 18.8125 28.638 18.8125 26.558V24.608C18.8125 22.528 19.8742 21.5205 22.0408 21.5205H26.4175C28.595 21.5205 29.6458 22.528 29.6458 24.608V26.558C29.6458 28.638 28.5842 29.6455 26.4175 29.6455ZM22.0408 23.1455C20.665 23.1455 20.4375 23.5138 20.4375 24.608V26.558C20.4375 27.6522 20.665 28.0205 22.0408 28.0205H26.4175C27.7933 28.0205 28.0208 27.6522 28.0208 26.558V24.608C28.0208 23.5138 27.7933 23.1455 26.4175 23.1455H22.0408Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9595 29.6462H9.58283C7.40533 29.6462 6.35449 28.6387 6.35449 26.5587V19.192C6.35449 17.112 7.41616 16.1045 9.58283 16.1045H13.9595C16.137 16.1045 17.1878 17.112 17.1878 19.192V26.5587C17.1878 28.6387 16.1262 29.6462 13.9595 29.6462ZM9.58283 17.7295C8.20699 17.7295 7.97949 18.0978 7.97949 19.192V26.5587C7.97949 27.6528 8.20699 28.0212 9.58283 28.0212H13.9595C15.3353 28.0212 15.5628 27.6528 15.5628 26.5587V19.192C15.5628 18.0978 15.3353 17.7295 13.9595 17.7295H9.58283V17.7295Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9595 14.4795H9.58283C7.40533 14.4795 6.35449 13.472 6.35449 11.392V9.44199C6.35449 7.36199 7.41616 6.35449 9.58283 6.35449H13.9595C16.137 6.35449 17.1878 7.36199 17.1878 9.44199V11.392C17.1878 13.472 16.1262 14.4795 13.9595 14.4795ZM9.58283 7.97949C8.20699 7.97949 7.97949 8.34783 7.97949 9.44199V11.392C7.97949 12.4862 8.20699 12.8545 9.58283 12.8545H13.9595C15.3353 12.8545 15.5628 12.4862 15.5628 11.392V9.44199C15.5628 8.34783 15.3353 7.97949 13.9595 7.97949H9.58283V7.97949Z",
    fill: "#292D32"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.16699,
    y: 7.16699,
    width: 8.66667,
    height: 6.5,
    fill: "#292D32"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.167,
    y: 22.333,
    width: 8.66667,
    height: 6.5,
    fill: "#292D32"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.167,
    y: 7.16699,
    width: 8.66667,
    height: 11.9167,
    fill: "#292D32"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.16699,
    y: 16.917,
    width: 8.66667,
    height: 11.9167,
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardR);
export default __webpack_public_path__ + "static/media/DashboardR.a67316c99b6bca31d452639cf0dc36b5.svg";
export { ForwardRef as ReactComponent };